// extracted by mini-css-extract-plugin
module.exports = {"migri-container":"MigriWidget_migri-container__77DYc"};